import type { ReactNode } from "react";

interface IBlurTextProps {
  text?: string;
  isBlurred?: boolean;
  children?: ReactNode;
}

const BlurText: React.FC<IBlurTextProps> = ({
  text = "*********",
  isBlurred,
  children,
}) => {
  return isBlurred ? (
    <div className="!text-primary-white select-none text-base blur-sm">
      {text}
    </div>
  ) : (
    <>{children}</>
  );
};

export default BlurText;
